// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3sPc2","title":"BackImages_title__1OtYT","images":"BackImages_images__uxN8q"};